import React from 'react';

function PlatformToggle({ on = false, onChange, ariaLabel }) {
  return (
    <button
      type="button"
      className={`platform-toggle ${on ? 'platform-toggle--on' : ''}`}
      onClick={() => onChange?.(!on)}
      aria-label={ariaLabel}
      aria-pressed={on}
    >
      <span className="platform-toggle-knob" />
    </button>
  );
}

export default PlatformToggle;
